// extracted by mini-css-extract-plugin
export default {"footer":"eWToeB1bVYhmiVZ1itXX","info":"ysoKvbB3CSkpaxozLRYa","spacer":"M18nstQZyJKLGuN3vzO_","legalLink":"ag7nT4PUaVbZ5uAXPEte"};